import {
  getPartialPipelinesList,
  getPartialCustomObjectInstanceList,
} from '../../routines';

const initialState = {
  list: {
    pipeline: [],
  },
  loading: false,
  error: null,
};

const partialEntityListReducer = (state = initialState, action) => {
  switch (action.type) {
    case getPartialPipelinesList.TRIGGER:
    case getPartialCustomObjectInstanceList.TRIGGER: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }

    case getPartialPipelinesList.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        list: {
          ...state.list,
          pipeline: action.payload.data,
        },
      };

    case getPartialCustomObjectInstanceList.SUCCESS: {
      const { level } = action.payload;
      return {
        ...state,
        loading: false,
        error: null,
        list: {
          ...state.list,
          [level]: action.payload.data,
        },
      };
    }

    case getPartialPipelinesList.FAILURE:
    case getPartialCustomObjectInstanceList.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    default: {
      return state;
    }
  }
};

export default partialEntityListReducer;
